// ==========================================================
// PRICE CONFIG (UI only)
// ==========================================================
const PRICE_CONFIG = {
  Flat: {
    unit: "m2",
    ranges: [
      { label: "Less than 50 m²", min: null, max: 50 },
      { label: "51 – 80 m²", min: 51, max: 80 },
      { label: "81 – 120 m²", min: 81, max: 120 },
      { label: "121 – 180 m²", min: 121, max: 180 },
      { label: "181 – 350 m²", min: 181, max: 350 },
      { label: "351 – 500 m²", min: 351, max: 500 },
      { label: "501 – 1000 m²", min: 501, max: 1000 },
    ],
  },

  "House, villa, detached": {
    unit: "m2",
    ranges: [
      { label: "Less than 80 m²", min: null, max: 80 },
      { label: "81 – 180 m²", min: 81, max: 180 },
      { label: "181 – 240 m²", min: 181, max: 240 },
      { label: "241 – 350 m²", min: 241, max: 350 },
      { label: "351 – 500 m²", min: 351, max: 500 },
      { label: "501 – 750 m²", min: 501, max: 750 },
      { label: "751 – 1000 m²", min: 751, max: 1000 },
    ],
  },

  Commercial: {
    unit: "m2",
    ranges: [
      { label: "Less than 50 m²", min: null, max: 50 },
      { label: "51 – 80 m²", min: 51, max: 80 },
      { label: "81 – 120 m²", min: 81, max: 120 },
      { label: "121 – 180 m²", min: 121, max: 180 },
      { label: "181 – 350 m²", min: 181, max: 350 },
      { label: "351 – 500 m²", min: 351, max: 500 },
      { label: "501 – 750 m²", min: 501, max: 750 },
    ],
  },

  "Individual office": {
    unit: "m2",
    ranges: [
      { label: "Less than 50 m²", min: null, max: 50 },
      { label: "51 – 80 m²", min: 51, max: 80 },
      { label: "81 – 120 m²", min: 81, max: 120 },
      { label: "121 – 180 m²", min: 121, max: 180 },
      { label: "181 – 350 m²", min: 181, max: 350 },
      { label: "351 – 500 m²", min: 351, max: 500 },
      { label: "501 – 1000 m²", min: 501, max: 1000 },
    ],
  },

  Building: {
    unit: "units",
    ranges: [
      { label: "Less than 5 units", min: null, max: 4 },
      { label: "5 – 10 units", min: 5, max: 10 },
      { label: "11 – 30 units", min: 11, max: 30 },
      { label: "31 – 60 units", min: 31, max: 60 },
      { label: "61 – 120 units", min: 61, max: 120 },
      { label: "121 – 180 units", min: 121, max: 180 },
      { label: "181 – 250 units", min: 181, max: 250 },
    ],
  },
};


// ==========================================================
// RENDER PRICE TAB (EDIT MODE + GLOBAL DELIVERY DAYS)
// ==========================================================
export function renderPriceTab(existingPrices = [], deliveryDays = 5) {
  const priceMap = new Map();

  existingPrices.forEach(p => {
    const key = `${p.property_type}|${p.surface_min}|${p.surface_max}`;
    priceMap.set(key, p);
  });

  return `
    <div class="space-y-6">

      <!-- GLOBAL DELIVERY DAYS -->
      <div class="p-4 bg-blue-50 border rounded">
        <label class="block text-sm font-semibold mb-1">
          Delivery time (days)
        </label>
        <input
          id="global-delivery-days"
          type="number"
          min="1"
          class="border rounded px-3 py-2 w-32"
          value="${deliveryDays}"
        />
        <p class="text-xs text-gray-500 mt-1">
          Applies to all prices
        </p>
      </div>

      ${Object.entries(PRICE_CONFIG).map(([type, cfg]) => `
        <div class="border rounded-lg p-4">
          <h3 class="text-lg font-semibold mb-3">${type}</h3>

          <div class="space-y-2">
            ${cfg.ranges.map(r => {
              const key = `${type}|${r.min}|${r.max}`;
              const existing = priceMap.get(key) || {};

              return `
                <div class="grid grid-cols-3 gap-3 items-center text-sm">
                  <span>${r.label}</span>

                  <input
                    type="number"
                    class="price-input border rounded px-2 py-1"
                    placeholder="€"
                    value="${existing.price ?? ""}"
                    data-property-type="${type}"
                    data-surface-min="${r.min}"
                    data-surface-max="${r.max}"
                    data-unit="${cfg.unit}"
                  />

                  <span class="text-gray-400">${cfg.unit}</span>
                </div>
              `;
            }).join("")}
          </div>
        </div>
      `).join("")}

      <button
        id="save-prices-btn"
        class="bg-green-600 text-white px-6 py-2 rounded"
      >
        Save prices
      </button>
    </div>
  `;
}

// ==========================================================
// SAVE HANDLER (GLOBAL DELIVERY DAYS)
// ==========================================================
export function initPriceSaveHandler() {
  const btn = document.getElementById("save-prices-btn");
  if (!btn) return;

  btn.addEventListener("click", async () => {
    const deliveryDays =
      parseInt(document.getElementById("global-delivery-days")?.value, 10) || 5;

    const prices = [];

    document.querySelectorAll(".price-input").forEach(input => {
      const price = parseFloat(input.value);
      if (isNaN(price)) return;

      prices.push({
        property_type: input.dataset.propertyType,
        surface_min:
          input.dataset.surfaceMin !== "null"
            ? Number(input.dataset.surfaceMin)
            : null,
        surface_max:
          input.dataset.surfaceMax !== "null"
            ? Number(input.dataset.surfaceMax)
            : null,
        unit_type: input.dataset.unit,
        price,
      });
    });

    if (!prices.length) {
      alert("Please enter at least one price");
      return;
    }

    const res = await fetch("/api/advisor/prices", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        prices,
        delivery_days: deliveryDays,
      }),
    });

    if (res.ok) {
      alert("✅ Prices saved");
    } else {
      alert("❌ Error saving prices");
    }
  });
}
